const accs = document.querySelectorAll("button.accordion");

accs.forEach( accordionItem => {
  accordionItem.addEventListener("click", (e) => {
    e.preventDefault();
    accordionItem.classList.toggle("active");
    let panel = accordionItem.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
});